import './index.scss';

let timer = null;

export default {
    name: 'chj-inputline',
    props: {
        value: null,
        inputType: {
            type: String,
            default: 'input'
        },
        rows: {
            type: Number,
            default: 3
        },
        placeholder: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        tips: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        disabledBtn: {
            type: Boolean,
            default: false
        },
        required: Boolean,
        errorTips: {
            type: String,
            default: ''
        },
        inputErr: '',
        maxlength: {
            type: Number,
            default: 50
        },
        type: {
            type: String,
            default: 'text'
        }
    },
    data() {
        return {
            vcodeText: '获取验证码',
            patternReg: {
                tel: /^1[3-9][0-9]{9}$/
            },
            vActive: !this.disabledBtn
        };
    },
    computed: {
        inputListeners() {
            return {
                ...this.$listeners,
                input: event => {
                    this.$emit('input', event.target.value);
                }
            };
        }
    },
    watch: {
        disabledBtn() {
            this.vActive = !this.disabledBtn;
        }
    },
    mounted() {},
    methods: {
        btnEvent() {
            if (
                this.inputType === 'vcode' &&
                this.vActive &&
                !this.disabledBtn
            ) {
                this.sendSms();
            }
        },
        sendSms() {
            this.startCount();
            this.$emit('send');
        },
        startCount() {
            this.vcodeText = '60s';
            this.vActive = false;
            let count = 60;
            timer = setInterval(() => {
                count--;
                if (count < 1) {
                    this.vcodeText = '重新获取';
                    this.vActive = !this.disabledBtn;
                    clearInterval(timer);
                } else {
                    this.vcodeText = `${count}s`;
                }
            }, 1000);
        },
        clearCount() {
            this.vcodeText = '重新获取';
            this.vActive = !this.disabledBtn;
            clearInterval(timer);
        }
    }
};
